import { BaseHistoryTrail } from "../../../../common/base-history-trail";
import { useView, observable } from "aurelia-framework";
import { GetCwSelfAssessmentReviewResponse } from "../../../../../../models/cwsa/cwsa.models";
import { ConfigService } from "@rightship-tech/common-ui/services/basic/config.service";
import { NotificationClientService } from "../../../../../../services/basics/notification-client.service";
import { QueriesClientService } from "../../../../../../services/queries/queries-client.services";
import { I18N } from "aurelia-i18n";
import * as Enumerable from "linq";
import moment from 'moment';
import { EntityTypes } from "@rightship-tech/common-ui/models/basic.models";

class AuditItem {
    action: string;
    actionDetails: string;
    timestamp: Date;
    userName: string;
}

@useView('views/pages/modules/cwsa/tabs/history-trail/cwsa-history-trail.html')
export class CwsaHistoryTrail extends BaseHistoryTrail<GetCwSelfAssessmentReviewResponse> {

    private _id: number;
    public historyTrailLoading: boolean = false;
    public audits: any[] = [];
    public currentVm: CwsaHistoryTrail = this;
    public items: AuditItem[] = [];
    public filteredData: any[];
    public lastPage: number;
    public pageCount: number = 5;
    public pageCountSet: any[] = [
        { label: 10, value: 10 },
        { label: 50, value: 50 },
        { label: 100, value: 100 }
    ];

    @observable
    public currentPage: number = 1;

    constructor(notificationClientService: NotificationClientService, i18N: I18N, private queriesClientService: QueriesClientService, configService: ConfigService) {
        super(configService, notificationClientService, i18N);
    }

    activate(args: { entityId: number }) {
        this._id = args.entityId;
        this.refreshData(args.entityId);
    }

    public refreshData(id: number) {
        if (this.audits && this.audits.length > 0) {
            this.filteredData = this.getFiltered();
        } else {
            this.queriesClientService.getData(`/odata/RightShipAudits/GetAudits(entityTypeId=${EntityTypes.CrewWelfare},entityId=${id})?$orderby=timestamp desc`).then(x => {
                this.audits = x.value;
                this.filteredData = this.getFiltered();
            });
        }
    }

    public formatDateTime(date: Date): string {
        return moment(date).format("DD MMM YYYY, HH:mm");
    }

    public getFiltered(): any[] {
        const items = Enumerable.from(this.audits).orderByDescending(x => x.timestamp);
        const skip = (this.currentPage - 1) * this.pageCount;
        const count = items.count();
        this.lastPage = Math.ceil(count / this.pageCount);
        return items.skip(skip).take(this.pageCount).toArray();
    }

    public currentPageChanged() {
        if (this.currentPage >= 1) this.refreshData(this._id);
    }
}